import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=6b3644eb&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=6b3644eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3644eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3644eb')) {
      api.createRecord('6b3644eb', component.options)
    } else {
      api.reload('6b3644eb', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=6b3644eb&scoped=true&", function () {
      api.rerender('6b3644eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2S6lyemDqHjrb/JS/teamMember.vue"
export default component.exports